import { render, staticRenderFns } from "./historySearch.vue?vue&type=template&id=07318220&scoped=true&"
import script from "./historySearch.vue?vue&type=script&lang=js&"
export * from "./historySearch.vue?vue&type=script&lang=js&"
import style0 from "./historySearch.vue?vue&type=style&index=0&id=07318220&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07318220",
  null
  
)

export default component.exports